/**
 * VENDOR MODULES
 */
import React from 'react';

import GridOdd from 'shared/components/outcomes/grids/GridOdd';

/***/
function Place(props) {
  return (
    <div className="grid-item w-2/12 flex items-center justify-center">
      <GridOdd
        {...{
          ...props,
          class_names: ['pz_2'],
          market_type_group_id: 502
        }}
      />
    </div>
  );
}

export default Place;

